import { useEffect } from "react";
import { X } from "lucide-react";

export function LegalModal({ open, onClose, data }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open || !data) return null;
  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center p-5"
      style={{ background: "rgba(6,4,10,0.8)", backdropFilter: "blur(8px)" }}
      onClick={onClose}
      data-testid="legal-modal"
    >
      <div
        className="max-w-lg w-full"
        style={{ background: "#120C1C", border: "1px solid var(--glass-border)", borderRadius: 20, padding: "2rem", maxHeight: "80vh", overflowY: "auto" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-4 gap-4">
          <h3 className="font-head text-xl sm:text-2xl font-bold">{data.title}</h3>
          <button className="btn-ghost p-2 rounded-full" onClick={onClose} data-testid="legal-close-btn" aria-label="Закрыть">
            <X size={18} />
          </button>
        </div>
        <p className="leading-relaxed whitespace-pre-line" style={{ color: "var(--text-sec)" }}>
          {data.body}
        </p>
      </div>
    </div>
  );
}

export function RedirectModal({ open, onClose, onConfirm, modal }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center p-5"
      style={{ background: "rgba(6,4,10,0.8)", backdropFilter: "blur(8px)" }}
      onClick={onClose}
      data-testid="redirect-modal"
    >
      <div
        className="max-w-md w-full text-center"
        style={{ background: "#120C1C", border: "1px solid var(--glass-border)", borderRadius: 20, padding: "2.2rem" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="font-head text-xl sm:text-2xl font-bold mb-3">{modal.title}</h3>
        {modal.text && <p className="mb-7" style={{ color: "var(--text-sec)" }}>{modal.text}</p>}
        <div className="flex flex-col sm:flex-row gap-3">
          <button className="btn-grad px-7 py-3.5 flex-1" onClick={onConfirm} data-testid="redirect-confirm-btn">
            {modal.confirm_text}
          </button>
          <button className="btn-ghost px-7 py-3.5 flex-1" onClick={onClose} data-testid="redirect-cancel-btn">
            {modal.cancel_text}
          </button>
        </div>
      </div>
    </div>
  );
}
